import { setCookie } from "@/utils/cookies.utils";

const savePreferredLocaleCookie = (selectedLocale: string) => {
  const SIX_HOURS_IN_MILLISECONDS = 6 * 60 * 60 * 1000;
  setCookie("preferred_locale", selectedLocale, {
    expires: new Date(Date.now() + SIX_HOURS_IN_MILLISECONDS),
  });
};

export { savePreferredLocaleCookie };
